import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { MDBDatePickerComponent, ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { BancoService } from 'src/app/services/banco.service';
import { CuentaBancariaService } from 'src/app/services/cuenta-bancaria.service';
import { DepositoDocumentoService } from 'src/app/services/deposito-documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';

export interface IDepositoAgregado {
  banco: number | string;
  nombreBanco: string;
  cuenta: number | string;
  nroDeposito: number | string;
  fechaDeposito: Date | string;
  tipo_cuenta_bancaria_codigo: number;
}

@Component({
  selector: 'app-modal-destino-deposito',
  templateUrl: './modal-destino-deposito.component.html',
  styleUrls: ['../deposito-documentos.component.scss'],
})
export class ModalDestinoDepositoComponent implements OnInit {
  @ViewChild('datePickerFechaDeposito', { static: true }) datePickerFechaDeposito: MDBDatePickerComponent;
  @ViewChild('destinoDeposito', { static: true }) modalDestinoDeposito: ModalDirective;

  @Output() onSuccess: EventEmitter<IDepositoAgregado> = new EventEmitter<IDepositoAgregado>();

  // Form
  formHeader: FormGroup;
  initialValues: any;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  loading: boolean = false;
  listaMovimientosAll: Array<any> = null;
  listaMovimientos: Array<any> = null;
  listaMovimientosResumenAll: Array<any> = null;
  listaMovimientosResumen: Array<any> = null;
  mainTotalPaginas: number;
  mainTotalRegistros: number;
  paginationContext: PaginationContext = new PaginationContext();
  processing: boolean = false;

  optionsBanco: Array<any> = [];
  optionsCuenta: Array<any> = [];

  allowSave: boolean = false;

  // Constants
  readonly RB_TIPO_VISTA_RESUMEN: String = '_RB_TIPO_VISTA_RESUMEN_';
  readonly RB_TIPO_VISTA_DETALLE: String = '_RB_TIPO_VISTA_DETALLE_';

  // Utils
  private log: any;
  resumen_totales: { monto_total: number };
  MontoTotalResumen: number;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private depositoDocumentoService: DepositoDocumentoService,
    private rutService: RutService,
    private bancoService: BancoService,
    private datesService: DatesService,
    private cuentaBancariaService: CuentaBancariaService
  ) {
    this.log = this.clog.log('DESTINO-DEPOSITO');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10;

    this.getBancos();

    this.createForm();
    this.formChangesSubscriptions();
    this.reset();
  }

  private getBancos() {
    this.bancoService.obtenerBancoEmpresas(this.rutEmpresa, true, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.optionsBanco = registros.map((banco) => ({ value: banco.codigo, label: banco.nombre, ...banco }));
    });
  }

  private createForm() {
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_DETALLE],
      rut: [null, [Validators.required]],
      nombre: [null, [Validators.required]],
      banco: [null, [Validators.required]],
      cuenta: [null, [Validators.required]],
      nroDeposito: [null, [Validators.required]],
      fechaDeposito: [null, [Validators.required]],
    });

    this.initialValues = {
      rut: null,
      nombre: null,
      banco: null,
      cuenta: null,
      nroDeposito: null,
      fechaDeposito: null,
    };
  }

  formChangesSubscriptions() {
    this.formHeader.get('banco').valueChanges.subscribe((banco_codigo) => {
      if (!banco_codigo) {
        this.optionsCuenta = [];
        return;
      }
      this.getCuentas(banco_codigo);
    });
  }

  getCuentas(banco_codigo) {
    this.cuentaBancariaService.obtenerCuentaEmpresa(this.rutEmpresa, banco_codigo, true, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.formHeader.get('cuenta').setValue(null);
      this.formHeader.get('cuenta').markAsPristine();
      this.formHeader.get('cuenta').markAsUntouched();
      this.optionsCuenta = registros.map((cuenta) => ({ value: cuenta.numero_cuenta, label: cuenta.numero_cuenta, ...cuenta }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('cuenta'), this.optionsCuenta);
    });
  }

  load({ registros }) {
    this.setInitialValues();
    this.listaMovimientosAll = registros;

    this.resumen_totales = {
      monto_total: _.sumBy(this.listaMovimientosAll, 'monto'),
    };

    this.MontoTotalResumen = this.resumen_totales.monto_total;

    this.paginationContext.RecordsCount = this.listaMovimientosAll.length; //totalRegistros
    this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
    this.paginationContext.CurrentPage = 1;
    this.showPage(1);
    this.modalDestinoDeposito.show();
  }

  loadResumen({ registros }) {
    this.setInitialValues();
    this.listaMovimientosResumenAll = registros;
    //this.formHeader.get('tipoVista').setValue(this.RB_TIPO_VISTA_DETALLE)

    this.paginationContext.RecordsCount = this.listaMovimientosResumenAll.length; //totalRegistros
    this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
    this.paginationContext.CurrentPage = 1;
    this.showPageResumen(1);
  }

  setInitialValues() {
    this.optionsCuenta = [];
    this.formValidatorsService.setDefaultValues(this.formHeader, this.initialValues);
    this.enableFormHeader();
    this.formValidatorsService.reset(this.formHeader);
    this.datePickerFechaDeposito.clearDate();
    // this.formValidatorsService.setDefaultValues(this.formHeader, this.initialValues)
    const now = this.datesService.CurrentDateToShortTimeString();
    this.formHeader.get('fechaDeposito').setValue(now);
    this.formHeader.get('tipoVista').setValue(this.RB_TIPO_VISTA_DETALLE);
    this.disableGuardar();
  }

  enableFormHeader() {
    this.formHeader.get('rut').enable();
    this.formHeader.get('nombre').enable();
    this.formHeader.get('banco').enable();
    this.formHeader.get('cuenta').enable();
    this.formHeader.get('nroDeposito').enable();
    this.formHeader.get('fechaDeposito').enable();
  }

  disableFormHeader() {
    this.formHeader.get('rut').disable();
    this.formHeader.get('nombre').disable();
    this.formHeader.get('banco').disable();
    this.formHeader.get('cuenta').disable();
    this.formHeader.get('nroDeposito').disable();
    this.formHeader.get('fechaDeposito').disable();
  }

  enableGuardar() {
    this.allowSave = true;
  }

  disableGuardar() {
    this.allowSave = false;
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage);
  }
  showPageResumen(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaMovimientosResumen = _.slice(this.listaMovimientosResumenAll, start, start + this.paginationContext.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  reset() {
    // this.enableFormHeader()
    this.listaMovimientosAll = null;
    this.listaMovimientos = null;
    this.listaMovimientosResumenAll = null;
    this.listaMovimientosResumen = null;
    this.mainTotalPaginas = null;
    this.mainTotalRegistros = null;
  }

  async agregarBanco() {
    // nombre banco
    const arrayNombreBanco = this.optionsBanco.filter((p) => p.value === this.formHeader.get('banco').value);
    const nombreBanco = arrayNombreBanco && arrayNombreBanco.length > 0 ? arrayNombreBanco[0].nombre : '';

    // tipo_cuenta_bancaria_codigo
    const arrayCuentaSeleccionada = this.optionsCuenta.filter((p) => p.value === this.formHeader.get('cuenta').value);
    const tipo_cuenta_bancaria_codigo = arrayCuentaSeleccionada && arrayCuentaSeleccionada.length > 0 ? arrayCuentaSeleccionada[0].tipo_cuenta_bancaria_codigo : 0;

    const payload: any = {
      ..._.cloneDeep(this.formHeader.value),
      nombreBanco,
      tipo_cuenta_bancaria_codigo,
    };

    await this.agregarBancoDepositante(payload);
  }

  async agregarBancoDepositante({
    banco: banco_codigo_cuenta_bancaria,
    cuenta: numero_cuenta,
    nroDeposito: numero_deposito,
    fechaDeposito: fecha_deposito,
    nombreBanco,
    tipo_cuenta_bancaria_codigo,
  }: IDepositoAgregado) {
    const a = await new Promise((resolve) => {
      // Simulamos una operación asincrónica con setTimeout
      setTimeout(() => {
        this.log('agregar', { banco: banco_codigo_cuenta_bancaria, cuenta: numero_cuenta, nroDeposito: numero_deposito, fechaDeposito: fecha_deposito, nombreBanco, tipo_cuenta_bancaria_codigo });
        this.listaMovimientosAll.map((mov) => {
          mov.banco_codigo_cuenta_bancaria = banco_codigo_cuenta_bancaria;
          mov.tipo_cuenta_bancaria_codigo = tipo_cuenta_bancaria_codigo;
          mov.numero_cuenta = numero_cuenta;
          mov.numero_deposito = numero_deposito;
          mov.fecha_deposito = fecha_deposito;
          delete mov.__typename;
          // mov.nombre_banco_destino = nombreBanco // quitar despues
        });

        const rutSinDv: number = this.rutService.QuitarDV(this.rutService.Limpiar(this.formHeader.get('rut').value));
        const inputParams = {
          entidad: {
            depositante_rut: rutSinDv,
            depositante_nombre: this.formHeader.get('nombre').value.trim(),
            banco_codigo_cuenta_bancaria,
            tipo_cuenta_bancaria_codigo,
            numero_cuenta,
            numero_deposito,
            fecha_deposito,
            lista: this.listaMovimientosAll,
          },
          paginaActual: this.mainTotalPaginas,
          cantidadRegistrosPorPagina: this.mainTotalRegistros,
        };

        this.log('inputParams', JSON.stringify(inputParams));

        this.depositoDocumentoService.agregarBancoDepositante(inputParams, ({ mensajes, respuesta }) => {
          const ok = respuesta !== null;
          if (!ok) {
            this.messageRendererService.showErrors(mensajes);
            this.processing = false;

            return;
          }

          const { registros } = respuesta;
          this.listaMovimientosAll = registros;
          this.listaMovimientosAll.map((mov) => {
            mov.additionalData = {}; // quitar después
            mov.additionalData.nombre_banco_destino = nombreBanco;
          });

          this.disableFormHeader();
          this.enableGuardar();
          this.showPage(this.paginationContext.CurrentPage);
          resolve(registros);
        });
      }, 1000);
    });

    return await Promise.resolve(a);
  }

  async guardarDeposito() {
    this.processing = true;

    await this.agregarBanco();
    const lista = _.cloneDeep(this.listaMovimientosAll);
    lista.map((p) => {
      delete p.additionalData;
      delete p.__typename;
    });
    const inputParams = {
      entidad: {
        lista,
      },
      paginaActual: this.mainTotalPaginas,
      cantidadRegistrosPorPagina: this.mainTotalRegistros,
    };

    this.log('inputParams', JSON.stringify(inputParams));
    this.depositoDocumentoService.guardarDepositoDocumento(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.processing = false;

        return;
      }

      const { registros, totalPaginas, totalRegistros } = respuesta;

      // this.enableFormHeader()
      this.reset();
      this.processing = false;

      // const index: string = this.depositoDocumentoService.guardarPayload({ registros, totalPaginas, totalRegistros })
      this.toastService.success('Operación exitosa');
      this.modalDestinoDeposito.hide();
      this.onSuccess.emit();
      // this.router.navigate(['/finanzas/timbrarDeposito', index])
    });
  }
}
